import { render, staticRenderFns } from "./TrialStatusFilters.vue?vue&type=template&id=b2ac93e4&"
import script from "./TrialStatusFilters.vue?vue&type=script&lang=js&"
export * from "./TrialStatusFilters.vue?vue&type=script&lang=js&"
import style0 from "./TrialStatusFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VSelect,VSimpleCheckbox})
